import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../components/newsList';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { shopList3 },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip
                    id="225765"
                    type="recommend"
                    title="凰家尚品列表4"
                    groupName="凰家尚品"
                    content={shopList3}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
